import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { firstValueFrom, map } from 'rxjs';
import { AuthService } from '../../services/auth';
import { ProviderService } from '../../services/provider/provider.service';
import { UserStore } from '../../store/user/user.store';

export const providerMatchGuard: CanMatchFn = async () => {
  const router = inject(Router)
  const authService = inject(AuthService)
  const providerService = inject(ProviderService)
  const userStore = inject(UserStore)
  const decoded = authService.getDecodedToken()
  const userGroups: string[] = Array.isArray(decoded?.['cognito:groups']) ? decoded['cognito:groups'] : [];
  const isProviderUser = userGroups.indexOf('admin-provider') > -1 || userGroups.indexOf('provider') > -1 || userGroups.indexOf('admin-clinic') > -1;
  
  if (!isProviderUser) {
    return router.createUrlTree(['/not-authorized']);
  }

  if (Number(userStore.id()) > 0) {
    return true;
  }

  try {
    const provider = await firstValueFrom(
      providerService.getActiveProvider().pipe(
        map((response: any) => response)
      )
    );

    userStore.setParams({
      id: provider?.id ?? 0,
      active: provider?.active ?? false,
      clinic_id: provider?.clinic_id ?? 0,
      provider_id: provider?.provider_id ?? provider?.id ?? 0,
      onboarding_status: provider?.onboarding_status ?? 0,
      user_group: userGroups
    });
  } catch (error) {
    console.error('Provider match guard failed to hydrate provider:', error);
    return router.createUrlTree(['/login']);
  }

  return true;
};
